import logo from "../../images/p1a1.png"


export default function P1() {
  return (
    <img className="p" src={logo} alt="contact logo" />
   
  );
}